import { render, staticRenderFns } from "./appMain.vue?vue&type=template&id=35e494d8&scoped=true&"
import script from "./appMain.vue?vue&type=script&lang=js&"
export * from "./appMain.vue?vue&type=script&lang=js&"
import style0 from "./appMain.vue?vue&type=style&index=0&id=35e494d8&scoped=true&lang=css&"
import style1 from "./appMain.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e494d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\admin\\Documents\\baocaodieuhanh\\source\\vnta-qltp-frontend\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35e494d8')) {
      api.createRecord('35e494d8', component.options)
    } else {
      api.reload('35e494d8', component.options)
    }
    module.hot.accept("./appMain.vue?vue&type=template&id=35e494d8&scoped=true&", function () {
      api.rerender('35e494d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/presentation/view/resources/appMain.vue"
export default component.exports